export class GroupSecurityPrivs {
    public topic: {
        read: boolean;
        write: boolean;
    };

    public story: {
        read: boolean;
        write: boolean;
    };

    public assignment: {
        read: boolean;
        write: boolean;
    };

    public cost: {
        read: boolean;
        write: boolean;
    };

    // TODO: Get Story Privs
    public viewUserLocationPrivileges: boolean = true;
    public privId: string;

    constructor() {
        this.topic = {
            read: true,
            write: true,
        };

        this.story = {
            read: true,
            write: true,
        };

        this.assignment = {
            read: true,
            write: true,
        };

        this.cost = {
            read: true,
            write: true,
        };
    }
}
